import React from "react";

export default () => {
  return (
    <div
      style={{
        display: "flex",
        height: "50vh",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        color: "white",
        textAlign: "center"
      }}
    >
      <div>
        Please call us,
        <br />
        +82 10 7724 3715
        <br />
        +82 10 2677 5000
      </div>

      <div>
        or message us
        <br />
        instagram @dmyk_hotel
        <br />
        kakao jjb1118
        <br />
        line dmyk_hotel
      </div>
      <div>
        wifi
        <br />
        id: dmyk-welcome
        <br />
        pw: welcometodmyk
      </div>
    </div>
  );
};
